import jQuery = require('jquery');

import { Dispatcher } from '../redux/Dispatcher'
import { Keys, StateValues } from '../redux/Datastore'
import { Actions } from '../redux/Actions'
import { State } from '../redux/State'
import { Stack } from 'immutable';
import { Map, fromJS } from 'immutable'
import { cms_logging } from '../cms_logging'
import { CmsApi, AttachmentApiObject } from '../cms_api';
import { Point } from '../Point';
import { Id_location, Id_attachment } from '../api/Identifiers';

export class AttachmentUi {
    public static view_listener(old_state: State, new_state: State): void {
        //  awh todo - does this need a pointer to the dispatcher?
    }

    // When the user opts to save a new attachment, the newly completed attachment object is sent to the API, and the API goes into a progress bar  

    public static add_attachment_link_save(state: State, _dispatch_func: any, add_attachment_modal_link: HTMLInputElement) {
        let link_url: string = add_attachment_modal_link.value;
        let attachment_object: any = state.get_json(Keys.KEY_ADD_ATTACHMENT_OBJECT, {});// getJSObject(new_imm_state, KEY_ADD_ATTACHMENT_OBJECT, {});

        attachment_object.url = link_url;

        _dispatch_func(Actions.ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP, null);
        let obj:AttachmentApiObject = AttachmentApiObject.build_create_url_attachment(
            link_url, 
            Point.build_from_array(attachment_object.coord),
            Point.build_from_array(attachment_object.p1p2[0]),
            Point.build_from_array(attachment_object.p1p2[1]),
            Id_location.wrap(attachment_object.id_location));
          
        CmsApi.post_api_CreateAttachment_url(obj);
        // _dispatch_func(Actions.ACTION_CREATE_A, null);
        _dispatch_func(Actions.ACTION_SET_ADD_ATTACHMENT_STATE, StateValues.STATE_CREATING_ATTACHMENT_API_BUSY);
    }
    
    public static add_attachment_link_keydown(jquery_key_event: any, state: State, _dispatch_func: any): void {

        let add_attachment_modal_link:HTMLInputElement = <HTMLInputElement>document.getElementById('add_attachment_modal_link')        
        let is_valid:boolean = add_attachment_modal_link.validity.valid;
        let url:string = add_attachment_modal_link.value;

        if (is_valid) {
            $('#add_attachment_link_modal_save_button').prop('disabled', false);
        }
        else{
            $('#add_attachment_link_modal_save_button').prop('disabled', true);
        }
        if (jquery_key_event.which == 13) {
            if (!is_valid) {
                jquery_key_event.preventDefault();  // don't auto submit when the user hits enter if the url field is empty
            }
            else
            {
                AttachmentUi.add_attachment_link_save(state, _dispatch_func, add_attachment_modal_link);
            }
        }
    }


    public static update_map_url(state: State, reposition_icon: string, id_attachment: string, coord: Point) {
        let url = "./edit/edit.html?"
            + `xCoord=${coord.X}`
            + `&yCoord=${coord.Y}`
            + `&p1Coord=${state.drawing_p1p2.P1.toString()}`
            + `&p2Coord=${state.drawing_p1p2.P2.toString()}`
            + `&drawing_p1Coord=${state.drawing_p1p2.P1.toString()}`
            + `&drawing_p2Coord=${state.drawing_p1p2.P2.toString()}`
            + `&idFeature=${id_attachment}`
            + `&idLocation=${state.id_floor.toString()}`
            + `&icon=${reposition_icon}`
            + `&drawingid=${state.id_drawing.toString()}`
            + `&tilesURL=${state.tiles_url}`
            + `&edit_mode=attachment`
        let iframe = <HTMLIFrameElement>document.getElementById('photo_reposition_map_frame');
        if (iframe) {
            iframe.onload = function () {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({ msg_type: 'MAP_RESIZE' }, '*');
                    setTimeout(function () {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.postMessage({ msg_type: 'MAP_RESIZE' }, '*');
                        }
                    }, 200);
                }
            };
        }
        $('#photo_reposition_map_frame').attr('src', url)
    }

    public static open_link_clicked() {
        if (AttachmentUi.attachment_url){
            window.open(AttachmentUi.attachment_url, '_blank');
        }

    }


    private static attachment_url:string = null;

    private static readonly attachments_content = document.getElementById('view_attachment_modal_content');

    public static attachment_clicked(state: Map<any, any>, click_coordinate: number[], attachment_data: any, reposition_icon: string, _dispatch_func: any) {

        let is_3D_link = attachment_data.is_3D_link;
        let is_video_link = attachment_data.is_video_link;
        let __state = new State(state);
        let api_gateway = state.get(Keys.API_GATEWAY);
        let id_attachment: string = attachment_data.id_attachment;
        let coord: Point = Point.build_from_array(attachment_data.coords);

        AttachmentUi.attachment_url = attachment_data.url;
        let html = `<img src="${attachment_data.url}" style="max-width:550px; max-height:500px;" />`
        AttachmentUi.attachments_content.innerHTML = html;
        $('#button_delete_attachment').unbind('click')
        $('#button_delete_attachment').click(function () {
            console.log('deleting ' + id_attachment);
            ($('#confirm_delete_attachment_modal') as any).modal('show');
        })

         $('#button_confirm_delete_attachment').unbind('click')
         $('#button_confirm_delete_attachment').click(function() {
             CmsApi.delete_deleteattachment(Id_attachment.wrap(id_attachment));
         })

        AttachmentUi.update_map_url(__state, reposition_icon, id_attachment, coord); // update the embedded map iframe
        let view_attachment_modal = ($('#view_attachment_modal') as any);

        let reposition_tab_link = ($('a[href="#photo_reposition_tab_pane"]') as any);
        reposition_tab_link.off('shown.bs.tab.cmsview_reposition_resize');
        reposition_tab_link.on('shown.bs.tab.cmsview_reposition_resize', function () {
            let iframe = <HTMLIFrameElement>document.getElementById('photo_reposition_map_frame');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ msg_type: 'MAP_RESIZE' }, '*');
            }
        });

        view_attachment_modal.off('shown.bs.modal.cmsview_reposition_resize');
        view_attachment_modal.on('shown.bs.modal.cmsview_reposition_resize', function () {
            let iframe = <HTMLIFrameElement>document.getElementById('photo_reposition_map_frame');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ msg_type: 'MAP_RESIZE' }, '*');
            }
        });
        
        let div_photo_view_container: HTMLElement = document.getElementById('photo_view_container');
        let div_3D_link_view_container: HTMLElement = document.getElementById('3D_link_view_container');
        let div_video_link_view_container: HTMLElement = document.getElementById('video_link_view_container');
        let div_3D_button_link: HTMLElement = document.getElementById('button_open_360_link');

        
        if(is_3D_link) {
            let is_ios_device:any = __state.get_boolean(Keys.KEY_IS_IOS_DEVICE);
            div_photo_view_container.style.display = "none";
            div_3D_link_view_container.style.display = "block";
            div_3D_button_link.style.visibility = "visible";
            div_video_link_view_container.style.display = "none";
            if (is_ios_device) {
                let img = `<a target="_blank" href="${attachment_data.url}" id="3D_view_iframe_link"><img src="https://portalvhdsc1clt6c22szhn.blob.core.windows.net/cmsview/images/360_URL.PNG" style="max-width:550px; max-height:500px;" /></a>`
                div_3D_link_view_container.innerHTML=img;
                $('#3D_view_tab_frame').attr('src', '#');
            }
            else {
                $('#3D_view_tab_frame').attr('src', attachment_data.url);
            }
            $('#3D_link_link').attr('href', attachment_data.url);
            $('#video_view_tab_frame').attr('src', '#');
        }
        else if(is_video_link){
            let url = attachment_data.url.replace("watch?v=", "embed/");
            div_photo_view_container.style.display = "none";
            div_3D_link_view_container.style.display = "none";
            div_3D_button_link.style.visibility = "hidden";
            div_video_link_view_container.style.display = "block";
            $('#3D_view_tab_frame').attr('src', '#')
            $('#3D_link_link').attr('href', '#');
            $('#video_view_tab_frame').attr('src', url);

        }
        else{
            div_photo_view_container.style.display = "block";
    		div_3D_link_view_container.style.display = "none";
    		div_3D_button_link.style.visibility = "hidden";
    		div_video_link_view_container.style.display = "none";
            $('#3D_view_tab_frame').attr('src', '#')
            $('#3D_link_link').attr('href', '#');
            $('#video_view_tab_frame').attr('src', '#');


        }

        let photo_view_tab_pane = ($('a[href="#photo_view_tab_pane"]') as any);
        view_attachment_modal.modal('show');
        photo_view_tab_pane.tab('show');
    }
}


(window as any).ts_temp__add_attachment_link_keydown  = function(jquery_key_event: any, state: Map<any, any>, _dispatch_func: any): void {
    AttachmentUi.add_attachment_link_keydown(event, State.wrap(state), _dispatch_func);
};

(window as any).ts_temp__add_attachment_link_save = function(state: Map<any, any>, _dispatch_func: any): void {
    let add_attachment_modal_link: HTMLInputElement = <HTMLInputElement>document.getElementById('add_attachment_modal_link');
    AttachmentUi.add_attachment_link_save(State.wrap(state), _dispatch_func, add_attachment_modal_link)
};



// WEBPACK FOOTER //
// ./src/ts/ui/attachment_ui.ts